import request from "@/axios";

/**
 * 设备控制
 * @param {number|string} machineId 设备ID
 * @param {number} taskFlag 任务标志：1-开门，2-远程重启，3-关门，4-拉闸，5-合闸
 * @param {string} lineNo 线路号
 */
export function control(machineId, taskFlag, lineNo) {
	return request.post("/cabinet/control", { machineId, taskFlag, lineNo });
}


